import {types} from '../../types';

const setGetBonusHistoryListAction = (payload) => {
    return {
        type: types.report.SET_HISTORY_LIST,
        payload,
      }
}

export {
  setGetBonusHistoryListAction as SetGetBonusHistoryListAction
}